import _ from 'lodash'
import { SIGNING_UP, SIGNUP_SUCCESSFUL, SIGNUP_FAILED } from 'actions'

const initialState = {
  loading: false,
  error: {
    signup: false,
    blacklist: false,
    other: false,
  },
}
export default (state = initialState, action) => {
  switch (action.type) {
    case SIGNING_UP: {
      return _.merge({}, state, {
        loading: true,
      })
    }
    case SIGNUP_SUCCESSFUL: {
      return _.merge({}, state, {
        loading: false,
        error: {
          signup: false,
          blacklist: false,
          other: false,
        },
      })
    }
    case SIGNUP_FAILED: {
      const { signup, blacklist, other } = action.error || { other: true }
      return _.merge({}, state, {
        loading: false,
        error: {
          signup: !!signup,
          blacklist: !!blacklist,
          other: !!other,
        },
      })
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/reducers/pages/signup/index.js